export const en = {
  invitation: {
    setPassword: {
      title: 'Complete your registration on Slash',
      subTitle: 'Set a password to access your account.',
      fields: {
        password: 'New password',
        passwordConfirm: 'Confirm password',
      },
      rules: {
        length: '8 characters',
        upper: '1 uppercase letter',
        lower: '1 lowercase letter',
        digit: '1 number',
      },
      errors: {
        mismatch: 'Passwords do not match',
      },
      buttons: {
        submit: 'Confirm password',
      },
      success: {
        title: 'Registration completed',
        description:
          'Your password has been created successfully. Log in with your new credentials and start exploring the platform',
        cta: 'Go to login',
      },
      error: {
        title: 'An error occurred',
        description: 'Setting the password failed. Please try again or contact us',
        cta: 'Retry',
      },
      tokenExpired: {
        title: 'Invalid link',
        description:
          'The redirect to the password setup page is no longer valid. If you have already set a password, log in to Slash with your credentials. Otherwise, contact your platform Admin and request a new invitation.',
        cta: 'Regenerate token',
      },
    },
    confirmEmail: {
      success: {
        title: 'Email verified successfully',
        description:
          'The email has been verified. Log in with your credentials and start exploring the new organization.',
        cta: 'Go to login',
      },
      error: {
        title: 'An error occurred',
        description: 'Email verification failed. Please try again or contact us.',
        cta: 'Retry',
      },
      tokenExpired: {
        title: 'Invalid link',
        description:
          'The email verification link is no longer valid or has expired. Contact your Admin to receive a new link.',
        cta: 'Go to login',
      },
    },
  },
};
